import BaseApi from "@/core/HttpResources/BaseApi";
import Tag from '@/models/history/tag.model';
export default class HistoryService {

    async saveRecord(model: any): Promise<Array<any>> {
        var baseApi = new BaseApi("Record");
        return new Promise<Array<any>>((resolve, reject) =>
            baseApi.request(
                "POST",
                String(),
                model,
                {},
                response => resolve(response.data),
                reject,
                () => { }
            )
        );
    }

    async updateRecord(model: any): Promise<Array<any>> {
        var baseApi = new BaseApi("Record/"+ model.id);
        return new Promise<Array<any>>((resolve, reject) =>
            baseApi.request(
                "PUT",
                String(),
                model,
                {},
                response => resolve(response.data),
                reject,
                () => { }
            )
        );
    }

    async saveTag(model: any): Promise<Array<any>> {
        var baseApi = new BaseApi("Tag");
        return new Promise<Array<any>>((resolve, reject) =>
            baseApi.request(
                "POST",
                String(),
                model,
                {},
                response => resolve(response.data),
                reject,
                () => { }
            )
        );
    }

    async deleteTag(id: number) {
        var baseApi = new BaseApi(`Tag/${id}`);
        return new Promise<Tag>((resolve, reject) =>
            baseApi.request(
                "DELETE",
                String(),
                null,
                {},
                response => resolve(response.data),
                reject,
                () => { }
            )
        );
    }

    async getRecordById(id: number) {
        var baseApi = new BaseApi(`Record/${id}`);
        return new Promise<Tag>((resolve, reject) =>
            baseApi.request(
                "GET",
                String(),
                null,
                {},
                response => resolve(response.data),
                reject,
                () => { }
            )
        );
    }

    async getTagsByCriteria(criteria: string) {
        var baseApi = new BaseApi("Tag/GetTagsByCriteria/" + criteria);
        return new Promise<Array<Tag>>((resolve, reject) =>
            baseApi.request(
                "GET",
                String(),
                null,
                {},
                response => resolve(response.data),
                reject,
                () => { }
            )
        );
    }

    async getTags() {
        var baseApi = new BaseApi("Tag/GetAllTags");
        return new Promise<Array<Tag>>((resolve, reject) =>
            baseApi.request(
                "GET",
                String(),
                null,
                {},
                response => resolve(response.data),
                reject,
                () => { }
            )
        );
    }

    async getTagsByRecordTag(data: any) {
        var baseApi = new BaseApi("Tag/GetTagsByRecordTag");
        return new Promise<Array<Tag>>((resolve, reject) =>
            baseApi.request(
                "GET",
                String(),
                null,
                data,
                response => resolve(response.data),
                reject,
                () => { }
            )
        );
    }

    async getRecordsByTagsId(data: any) {
        var baseApi = new BaseApi("Record/GetRecordsByTagsId");
        return new Promise<Array<Tag>>((resolve, reject) =>
            baseApi.request(
                "POST",
                String(),
                data,
                {},
                response => resolve(response.data),
                reject,
                () => { }
            )
        );
    }
    
}